import React from "react";

export default function ContactFormBlock({ data }) {
  return (
    <div style={{ padding: "20px", background: "#111", borderRadius: "12px", color: "white", marginTop: "20px" }}>
      <h2>Contact Form</h2>

      <form style={{ marginTop: "15px" }}>
        {data.fields?.map((field, i) => (
          <input
            key={i}
            placeholder={field}
            style={{
              width: "100%",
              padding: "10px",
              marginBottom: "10px",
              borderRadius: "6px",
              border: "1px solid #555",
              background: "#1d1d1d",
              color: "white",
            }}
          />
        ))}

        <button
          style={{
            padding: "10px 20px",
            background: "#6C63FF",
            color: "white",
            border: "none",
            borderRadius: "6px",
          }}
        >
          Submit
        </button>
      </form>
    </div>
  );
}
